export const SUMMARY_TABLE_COLUMNS = {
  ROW_DESCRIPTION: "row-description",
  INITIAL_STOCK: "initial-stock",
  ENTRIES: "entries",
  EXITS: "exits",
  BIRTHS: "births",
  DEATHS: "deaths",
  FINAL_STOCK: "final-stock",
  TOTAL_ARROBA_PRODUCTION: "total-arroba-production",
};

export const AVG_DAILY_GAIN_TABLE_COLUMN = {
  AVG_HERD_SIZE: "avg-herd-size",
  PROD_PER_CATTLE_KG: "prod-per-cattle-kg",
  PROD_PER_CATTLE_ARROBA: "prod-per-cattle-arroba",
  TIMEFRAME: "timeframe",
  AVG_DAILY_GAIN: "avg-daily-gain",
};

export const WEIGHT_EVOLUTION_TABLE_COLUMNS = {
  CATEGORY: "category",
  INITIAL_AMOUNT: "initial-amount",
  WEIGHT_FOR_INITIAL_BALANCE: "weight-for-initial-balance",
  FINAL_AMOUNT: "final-amount",
  WEIGHT_FOR_FINAL_BALANCE: "weight-for-final-balance",
};

export const DETAILED_MOVEMENTS_TABLE_COLUMNS = {
  CATEGORY: "category",
  ENTRIES: "entries",
  ENTRIES_WEIGHT: "entries-weight",
  EXITS: "exits",
  EXITS_WEIGHT: "exits-weight",
  BIRTHS: "births",
  DEATHS: "deaths",
};

export const getSummaryTableColumns = (t) => [
  {
    id: SUMMARY_TABLE_COLUMNS.ROW_DESCRIPTION,
    label: "",
  },
  {
    id: SUMMARY_TABLE_COLUMNS.INITIAL_STOCK,
    label: t("movements:initial-stock"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.ENTRIES,
    label: t("movements:entry"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.EXITS,
    label: t("movements:exit"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.BIRTHS,
    label: t("movements:births"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.DEATHS,
    label: t("movements:deaths"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.FINAL_STOCK,
    label: t("movements:final-stock"),
  },
  {
    id: SUMMARY_TABLE_COLUMNS.TOTAL_ARROBA_PRODUCTION,
    label: t("arrobaBalance:total-arrobas-production"),
  },
];

export const getAvgDailyGainTableColumns = (t) => [
  {
    id: AVG_DAILY_GAIN_TABLE_COLUMN.AVG_HERD_SIZE,
    label: [
      t("livestock:average-herd").toUpperCase(),
      `(${t("common:measure.heads")})`,
    ].join(" "),
  },
  {
    id: AVG_DAILY_GAIN_TABLE_COLUMN.PROD_PER_CATTLE_KG,
    label: [
      `${t("common:production")}/${t("livestock:head")}`.toUpperCase(),
      `(${t("common:measure.KG")})`,
    ],
  },
  {
    id: AVG_DAILY_GAIN_TABLE_COLUMN.PROD_PER_CATTLE_ARROBA,
    label: [
      `${t("common:production")}/${t("livestock:head")}`.toUpperCase(),
      `(${t("common:measure.arroba")})`,
    ],
  },
  {
    id: AVG_DAILY_GAIN_TABLE_COLUMN.TIMEFRAME,
    label: [
      t("common:period").toUpperCase(),
      `(${t("common:measure.days")})`.toLowerCase(),
    ],
  },
  {
    id: AVG_DAILY_GAIN_TABLE_COLUMN.AVG_DAILY_GAIN,
    label: t("arrobaBalance:avg-daily-gain-short").toUpperCase(),
  },
];

export const getWeightEvolutionTableColumns = (t) => [
  {
    id: WEIGHT_EVOLUTION_TABLE_COLUMNS.CATEGORY,
    label: t("animalCategory:category").toUpperCase(),
  },
  {
    id: WEIGHT_EVOLUTION_TABLE_COLUMNS.INITIAL_AMOUNT,
    label: [
      t("common:initial-amount").toUpperCase(),
      `(${t("common:measure.heads")})`,
    ].join(" "),
  },
  {
    id: WEIGHT_EVOLUTION_TABLE_COLUMNS.WEIGHT_FOR_INITIAL_BALANCE,
    label: [
      t("arrobaBalance:weight-for-initial-balance").toUpperCase(),
      `(${t("common:measure.KG")})`,
    ].join(" "),
  },
  {
    id: WEIGHT_EVOLUTION_TABLE_COLUMNS.FINAL_AMOUNT,
    label: [
      t("common:final-amount").toUpperCase(),
      `(${t("common:measure.heads")})`,
    ].join(" "),
  },
  {
    id: WEIGHT_EVOLUTION_TABLE_COLUMNS.WEIGHT_FOR_FINAL_BALANCE,
    label: [
      t("arrobaBalance:weight-for-final-balance").toUpperCase(),
      `(${t("common:measure.KG")})`,
    ].join(" "),
  },
];

export const getDetailedMovementsTableColumns = (t) => [
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.CATEGORY,
    label: t("animalCategory:category"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.ENTRIES,
    label: t("movements:entries"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.ENTRIES_WEIGHT,
    label: t("movements:entries-weight"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.EXITS,
    label: t("movements:exits"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.EXITS_WEIGHT,
    label: t("movements:exits-weight"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.BIRTHS,
    label: t("movements:births"),
  },
  {
    id: DETAILED_MOVEMENTS_TABLE_COLUMNS.DEATHS,
    label: t("movements:deaths"),
  },
];
